// extracted by mini-css-extract-plugin
module.exports = {"smallMarginY":"styles-module__smallMarginY___38ePA","mediumMarginY":"styles-module__mediumMarginY___3uJpU","largeMarginY":"styles-module__largeMarginY___Op_sd"};